import type { Booking } from "@/types/camping";

/** Status, die einen Platz für überlappende Zeiträume blockieren (Fallback ohne API). */
export const BLOCKING_STATUSES = new Set([
  "requested",
  "reserved",
  "confirmed",
  "checked_in",
]);

/** Half-open stay [arrival, departure) — matches PostgreSQL daterange '[)'. */
export function staysOverlap(
  arrivalA: string,
  departureA: string,
  arrivalB: string,
  departureB: string,
): boolean {
  return arrivalA < departureB && departureA > arrivalB;
}

function bookingHardBlocksPitch(
  booking: Booking,
  pitchId: string,
  arrival: string,
  departure: string,
): boolean {
  if (!BLOCKING_STATUSES.has(booking.status)) return false;
  if (booking.pitch_id !== pitchId) return false;
  if (booking.pitch_assignment_mode !== "fixed" && booking.status !== "checked_in") return false;
  return staysOverlap(arrival, departure, booking.arrival_date, booking.departure_date);
}

/** Client-side fallback: active, nicht gesperrte Plätze ohne harte Belegung. */
export function availablePitchesForPeriod(
  pitches: import("@/types/camping").Pitch[],
  bookings: Booking[],
  arrival: string,
  departure: string,
): import("@/types/camping").Pitch[] {
  return pitches.filter((pitch) => {
    if (!pitch.is_active || pitch.is_blocked) return false;
    const blocked = bookings.some((b) =>
      bookingHardBlocksPitch(b, pitch.id, arrival, departure),
    );
    return !blocked;
  });
}
